import type { ChangeEvent } from 'react';
import { digitsOnly } from '../../../helpers';
import MaskedInput, { conformToMask } from '../../../helpers/text-mask';
import type { MaskConfig } from './mask-types';
import type { InputProps } from './types';
import { getMaskConfigProps } from './utils';

const ssnMasks = {
  standard: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  hyphenated: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
};

export const SsnInput = ({ format = 'hyphenated', onChange, value = '', ...rest }: InputProps<'ssn'> & MaskConfig) => {
  // always keep the value digits-only, keeping formatting only in the ui
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ name: rest.name, value: digitsOnly(event.target.value) });
  };

  const { maskConfigProps, nonConfigProps } = getMaskConfigProps(rest);

  return (
    <MaskedInput
      {...nonConfigProps}
      onChange={handleChange}
      type='text'
      pattern='[0-9]*'
      mask={ssnMasks[format]}
      value={value.trim() ? conformToMask(value, ssnMasks[format], maskConfigProps).conformedValue : value}
    />
  );
};
